import { useState, useCallback } from 'react';
import { UrlApi } from '../../../services/apirest';

export const useApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async (endpoint, options = {}) => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${UrlApi}${endpoint}`, {
        headers: {
          'Content-Type': 'application/json',
        },
        ...options,
      });
      
      if (!response.ok) {
        throw new Error(`Error HTTP: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const get = useCallback((endpoint) => {
    return fetchData(endpoint);
  }, [fetchData]);

  const post = useCallback((endpoint, data) => {
    return fetchData(endpoint, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }, [fetchData]);

  const put = useCallback((endpoint, data) => {
    return fetchData(endpoint, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }, [fetchData]);

  const remove = useCallback((endpoint) => {
    return fetchData(endpoint, {
      method: 'DELETE',
    });
  }, [fetchData]);

  return {
    loading,
    error,
    get,
    post,
    put,
    remove,
  };
};
